import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { WillSearchScreen } from "../components/steps/WillSearchScreen";

export function createWillSearchScreens(): FlowScreenConfig[] {
  return [
    {
      id: "admin_will_search_screen",
      layout: "full",
      customComponent: WillSearchScreen,
      isButtonDisabled: ({ answers }) => answers["admin_will_search_attested"] !== "true",
    },
  ];
}
